export default __webpack_public_path__ + "static/media/poster-hero.556c67d9.jpg";